import { render, staticRenderFns } from "./AIInvestmentAdvisor.vue?vue&type=template&id=23d9a25e&scoped=true&"
import script from "./AIInvestmentAdvisor.vue?vue&type=script&lang=js&"
export * from "./AIInvestmentAdvisor.vue?vue&type=script&lang=js&"
import style0 from "./AIInvestmentAdvisor.vue?vue&type=style&index=0&id=23d9a25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9a25e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VTextField})
